// 拷贝函数
export const merge = (...rest) => {
    let target = rest[0] || {};
    let src;
    let copy;
    let clone;
    let i = 1;
    let deep = false;
    if (typeof target === 'boolean') {
        deep = target;
        target = rest[1] || {};
        i++;
    }
    for (; i < rest.length; i++) {
        let option = rest[i];
        for (let name in option) {
            src = target[name];
            copy = option[name];
            if (deep && copy && typeof copy === 'object') {
                if (isArray(copy)) {
                    clone = src && isArray(src) ? src : [];
                } else {
                    clone = src && isObject(src) ? src : {};
                }
                target[name] = merge(clone, copy);
            } else if (copy !== undefined) {
                target[name] = copy;
            }
        }
    }
    return target;
};


// WEBPACK FOOTER //
// ./src/common/merge.js